
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Company() {
  const companyInfo = [
    { label: '商号', value: 'ナインバレー株式会社' },
    { label: '所在地', value: '〒753-0056 山口県山口市湯田温泉2丁目4-26' },
    { label: '設立', value: '2019年9月2日' },
    { label: '代表者', value: '代表取締役 九谷 直樹' },
    { label: '資本金', value: '100万円' },
    { label: '事業内容', value: '宿泊業（光のアート型グランピング施設の運営）\nマーケティング支援（ローカルマーケティングラボ）' },
    { label: 'URL', value: 'https://www.redondo.jp/' },
    { label: '企業理念', value: '「私たちは相互依存と能動的思考で人の成長を支えます」' }
  ];

  const timeline = [
    { year: '2019年', event: 'ナインバレー株式会社設立' },
    { year: '2020年', event: '山口県観光マーケティング事業開始' },
    { year: '2021年', event: '地域BPO事業部設立' },
    { year: '2022年', event: 'コンテンツ制作事業拡大' },
    { year: '2023年', event: '教育研修プログラム開始' },
    { year: '2024年', event: 'データドリブンマーケティング事業強化' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* パンくず */}
        <nav className="bg-gray-50 py-4">
          <div className="container mx-auto px-4">
            <div className="flex items-center space-x-2 text-sm">
              <a href="/" className="text-gray-500 hover:text-[#0B3D91] cursor-pointer">ホーム</a>
              <span className="text-gray-400">/</span>
              <span className="text-[#0B3D91] font-medium">会社情報</span>
            </div>
          </div>
        </nav>

        {/* ヘッダー */}
        <section className="py-16 bg-gradient-to-r from-[#0B3D91] to-[#40BFB4]">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              会社情報
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              地域と企業の持続可能な成長をサポートする私たちについて
            </p>
          </div>
        </section>

        {/* 代表挨拶 */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
                  代表挨拶
                </h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                <div>
                  <div className="relative">
                    <img 
                      src="https://static.readdy.ai/image/0736d0f97af205035455602030a0e7f5/07a2b76006955e75dd49a101c0fdaf82.jfif"
                      alt="代表取締役社長　九谷直樹"
                      className="w-full rounded-2xl shadow-lg"
                    />
                    {/* 動画再生ボタン */}
                    <div className="absolute inset-0 flex items-center justify-center">
                      <button className="bg-white/90 backdrop-blur-sm rounded-full p-4 shadow-lg cursor-pointer hover:bg-white transition-colors duration-200">
                        <div className="w-8 h-8 flex items-center justify-center">
                          <i className="ri-play-fill text-[#0B3D91] text-2xl"></i>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-2xl font-bold text-[#111827] mb-4">
                    代表取締役社長　九谷直樹
                  </h3>
                  <div className="prose prose-lg text-gray-600 space-y-4">
                    <p>
                      この度は、ナインバレー株式会社のホームページをご覧いただき、誠にありがとうございます。
                    </p>
                    <p>
                      弊社は山口の地に根ざし、お客様との信頼関係を大切にしながら事業を展開してまいりました。私たちが目指すのは、単なるサービスの提供ではなく、お客様の課題解決のパートナーとして、真に価値のあるソリューションをお届けすることです。
                    </p>
                    <p>
                      変化の激しい現代において、企業には常に新しい発想と柔軟な対応力が求められています。その中で私たちナインバレーは、相互依存と能動的思考で人の成長を支える企業でありたいと考えております。
                    </p>
                    <p>
                      地域の皆様、そして全国のお客様から信頼していただける企業として、私たち一人ひとりが持てる力を最大限に発揮し、お客様の成功に貢献できるよう全力で取り組んでまいります。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 会社概要 */}
        <section className="py-20 bg-[#F2F5F9]">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
                  会社概要
                </h2>
              </div>

              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                {companyInfo.map((info, index) => (
                  <div 
                    key={index} 
                    className={`grid grid-cols-1 md:grid-cols-3 ${index !== companyInfo.length - 1 ? 'border-b border-gray-100' : ''}`}
                  >
                    <div className="bg-gray-50 px-6 py-4 font-medium text-[#111827]">
                      {info.label}
                    </div>
                    <div className="md:col-span-2 px-6 py-4 text-gray-600">
                      {info.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 沿革 */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
                  沿革
                </h2>
              </div>

              <div className="relative">
                {/* タイムライン線 */}
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-[#40BFB4] transform md:-translate-x-1/2"></div>

                <div className="space-y-8">
                  {timeline.map((item, index) => (
                    <div key={index} className={`relative flex items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                      {/* 年表示 */}
                      <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-8 md:text-right' : 'md:pl-8 md:text-left'} ml-12 md:ml-0`}>
                        <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                          <div className="text-lg font-bold text-[#0B3D91] mb-2">{item.year}</div>
                          <div className="text-gray-600">{item.event}</div>
                        </div>
                      </div>

                      {/* 丸いポイント */}
                      <div className="absolute left-4 md:left-1/2 w-3 h-3 bg-[#40BFB4] rounded-full transform md:-translate-x-1/2 border-4 border-white shadow-md"></div>

                      {/* 空のスペース */}
                      <div className="hidden md:block md:w-1/2"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* アクセス */}
        <section className="py-20 bg-[#F2F5F9]">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-3xl lg:text-4xl font-bold text-[#111827] mb-4">
                  アクセス
                </h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* 地図 */}
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3314.5!2d131.47!3d34.18!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDEwJzQ4LjAiTiAxMzHCsDI4JzEyLjAiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className="w-full h-96"
                  ></iframe>
                </div>

                {/* アクセス情報 */}
                <div className="space-y-6">
                  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                    <h3 className="text-xl font-bold text-[#111827] mb-4">
                      所在地
                    </h3>
                    <div className="space-y-3">
                      <div className="flex items-start space-x-3">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-map-pin-line text-[#40BFB4]"></i>
                        </div>
                        <div>
                          <p className="font-medium text-[#111827]">ナインバレー株式会社</p>
                          <p className="text-gray-600">〒753-0056<br />山口県山口市湯田温泉2丁目4-26</p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-mail-line text-[#40BFB4]"></i>
                        </div>
                        <a href="mailto:info@redondo.jp" className="text-[#0B3D91] hover:underline cursor-pointer">
                          info@redondo.jp
                        </a>
                      </div>
                      <div className="flex items-center space-x-3">
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-external-link-line text-[#40BFB4]"></i>
                        </div>
                        <a 
                          href="https://maps.app.goo.gl/MRKRXpvZ4WDAGeaY8" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-[#0B3D91] hover:underline cursor-pointer"
                        >
                          Google Mapで見る
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
                    <h3 className="text-xl font-bold text-[#111827] mb-4">
                      交通手段
                    </h3>
                    <div className="space-y-3">
                      <div className="flex items-start space-x-3">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-train-line text-[#40BFB4]"></i>
                        </div>
                        <div>
                          <p className="font-medium text-[#111827]">JR山口線</p>
                          <p className="text-gray-600 text-sm">湯田温泉駅より徒歩3分</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-3">
                        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-car-line text-[#40BFB4]"></i>
                        </div>
                        <div>
                          <p className="font-medium text-[#111827]">お車でお越しの場合</p>
                          <p className="text-gray-600 text-sm">中国自動車道 小郡ICより約10分<br />駐車場完備</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
